import { render, staticRenderFns } from "./ProtagonistList.vue?vue&type=template&id=7db7ae74&scoped=true"
import script from "./ProtagonistList.vue?vue&type=script&lang=js"
export * from "./ProtagonistList.vue?vue&type=script&lang=js"
import style0 from "./ProtagonistList.vue?vue&type=style&index=0&id=7db7ae74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db7ae74",
  null
  
)

export default component.exports